import { ENDPOINTS } from '../api/endpoints';
import { config } from '../config/environment';

export interface LinkPreviewData {
  url: string;
  title: string;
  description: string;
  image: string;
}

export const getLinkPreview = async (url: string): Promise<LinkPreviewData> => {
  // Check if the URL starts with https, if not, add it
  const secureUrl = url.startsWith('https://') ? url : `https://${url}`;

  console.log('Sending POST request to:', ENDPOINTS.LINK_PREVIEW, 'with data:', { link: secureUrl });
  try {
    const response = await fetch(`${config.apiBaseUrl}${ENDPOINTS.LINK_PREVIEW}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify({ link: secureUrl }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return {
      url: data.url || secureUrl,
      title: data.title || '',
      description: data.description || '',
      image: data.image || '',
    };
  } catch (error) {
    console.error('Error fetching link preview:', error);
    throw error;
  }
};
